import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import * as Links from "../../lib/links";

import Modal from "../../../common/components/Modal";

export default function Unauthorized(props) {
    const { t } = useTranslation();
    const show = useSelector(state => state.panel.showUnauthorized);

    if (show) {
        return (
            <div className="unauthorized">
                <Modal
                    show={show}
                    zIndex="65536"
                    header={t("SessionWasClosed")}
                    actions={[
                        {
                            onClick: () => (window.location = "/"),
                            text: t("Home"),
                            props: { solid: true },
                        },

                        {
                            onClick: () => (window.location = Links.Login()),
                            text: t("Login"),
                            props: { invert: true },
                        },
                    ]}
                />
            </div>
        );
    } else {
        return props.children;
    }
}
